import store from '@/store/index'
import * as trackedVehicleHelpers from '@/store/assets/vehicles/trackedVehicles.helpers'
import * as trackedUnitHelpers from '@/store/units/trackedUnits.helpers'

export default {}

/**
 * Returns the full state object of the asset tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['monitoring/tripReplayWidgetModule/get']
}

export const getVehicle = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getVehicle']
}

export const setVehicle = (vehicle) => {
  store.commit('monitoring/tripReplayWidgetModule/setVehicle', vehicle)
}

export const getUnit = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getUnit']
}

export const setUnit = (unit) => {
  store.commit('monitoring/tripReplayWidgetModule/setUnit', unit)
}

export const getDate = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getDate']
}

export const setDate = (date) => {
  store.commit('monitoring/tripReplayWidgetModule/setDate', date)
}

export const getTrips = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getTrips']
}

export const getSelectedTrip = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getSelectedTrip']
}

/**
 * Set the selected trip by specifying the trip's index. An
 * optional position of 'first' or 'last' can be provided
 * to jump to the first or last record in the trip.
 *
 * @param tripIdx {int}
 * @param position {string} Can be 'first' or 'last'
 */
export const setSelectedTrip = (tripIdx, position = 'first') => {
  store.commit('monitoring/tripReplayWidgetModule/setSelectedTrip', { tripIdx, position })
}

export const selectNextTrip = () => {
  store.commit('monitoring/tripReplayWidgetModule/selectNextTrip')
}

export const selectPreviousTrip = () => {
  store.commit('monitoring/tripReplayWidgetModule/selectPreviousTrip')
}

export const clearTrips = () => {
  store.commit('monitoring/tripReplayWidgetModule/clearTrips')
}

export const getViewMode = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getViewMode']
}

export const setViewMode = (viewMode) => {
  store.commit('monitoring/tripReplayWidgetModule/setViewMode', viewMode)
}

export const setReplayMode = (replayMode) => {
  store.commit('monitoring/tripReplayWidgetModule/setReplayMode', replayMode)
}

export const getReplayMode = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getReplayMode']
}

/**
 * Sets the current replay speed.
 *
 * 0 = Paused, -1 = Rewind, 1 = Play, < -1 = Rewind Fast, > 1 Forward Fast
 *
 * @param replaySpeed
 */
export const setReplaySpeed = (replaySpeed) => {
  store.commit('monitoring/tripReplayWidgetModule/setReplaySpeed', replaySpeed)
}

export const getReplaySpeed = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getReplaySpeed']
}

/**
 * Get the current telemetry for the point in time in the replay.
 *
 * @returns null|Object
 */
export const getTelemetry = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getTelemetry']
}

/**
 * Set the current telemetry for the point in time in the replay.
 *
 * @param telemetry
 */
export const setTelemetry = (telemetry) => {
  store.commit('monitoring/tripReplayWidgetModule/setTelemetry', telemetry)
}

export const getIsFirstRecord = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getIsFirstRecord']
}

export const setIsFirstRecord = (isFirstRecord) => {
  store.commit('monitoring/tripReplayWidgetModule/setIsFirstRecord', isFirstRecord)
}

export const getIsLastRecord = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getIsLastRecord']
}

export const setIsLastRecord = (isLastRecord) => {
  store.commit('monitoring/tripReplayWidgetModule/setIsLastRecord', isLastRecord)
}

export const getIsFirstTrip = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getIsFirstTrip']
}

export const getIsLastTrip = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getIsLastTrip']
}

export const incReplaySpeed = () => {
  store.commit('monitoring/tripReplayWidgetModule/incReplaySpeed')
}

export const decReplaySpeed = () => {
  store.commit('monitoring/tripReplayWidgetModule/decReplaySpeed')
}

export const incRecordIdx = () => {
  store.commit('monitoring/tripReplayWidgetModule/incRecordIdx')
}

export const decRecordIdx = () => {
  store.commit('monitoring/tripReplayWidgetModule/decRecordIdx')
}

export const setRecordIdx = (recordIdx, panTo = false) => {
  store.commit('monitoring/tripReplayWidgetModule/setRecordIdx', { recordIdx, panTo })
}

export const reset = () => {
  store.commit('monitoring/tripReplayWidgetModule/reset')
}

export const getTripProgress = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getTripProgress']
}

export const getIsTodaysTrips = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getIsTodaysTrips']
}

export const setTooManyIcons = (tooManyIcons) => {
  store.commit('monitoring/tripReplayWidgetModule/setTooManyIcons', tooManyIcons)
}

export const getTooManyIcons = () => {
  return store.getters['monitoring/tripReplayWidgetModule/getTooManyIcons']
}

export const updateTripMarkers = () => {
  store.commit('monitoring/tripReplayWidgetModule/updateTripMarkers')
}

export const assetCount = () => {
  return trackedVehicleHelpers.trackedVehicleCount() +
  trackedUnitHelpers.trackedUnitCount()
}

export const setFirstAvailableAsset = () => {
  if (trackedVehicleHelpers.trackedVehicleCount() > 0) {
    let vehicle = getVehicle()
    if (vehicle === null) {
      // Try and set a vehicle based on the find dialog
      vehicle = trackedVehicleHelpers.trackedVehicle()
      if (vehicle !== null) {
        setVehicle(Object.assign({}, vehicle))
      }
    }
  } else if (trackedUnitHelpers.trackedUnitCount() > 0) {
    let unit = getUnit()
    if (unit === null) {
      unit = trackedUnitHelpers.trackedUnit()
      if (unit !== null) {
        setUnit(Object.assign({}, unit))
      }
    }
  } else {
    setUnit(null)
    setVehicle(null)
  }
}



// WEBPACK FOOTER //
// ./src/store/monitoring/tripReplayWidget.helpers.js